module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "login_div"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "login_form",
    attrs: {
      "model": _vm.loginForm
    }
  }, [_c('el-form-item', [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "prop": "account"
    }
  }, [_vm._v("用户名")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", $$v)
      },
      expression: "loginForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "prop": "password"
    }
  }, [_vm._v("密    码")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "prop": "verificationCode"
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleLogin($event)
      }
    },
    model: {
      value: (_vm.loginForm.verificationCode),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "verificationCode", $$v)
      },
      expression: "loginForm.verificationCode"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkCode),
      expression: "checkCode"
    }],
    staticClass: "verificationCode",
    attrs: {
      "type": "button"
    },
    domProps: {
      "value": (_vm.checkCode)
    },
    on: {
      "click": _vm.createCode,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkCode = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "submit_login_button",
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleLogin($event)
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('el-button', {
    staticClass: "submit_common_button",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleForgetPwd($event)
      }
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('el-button', {
    staticClass: "submit_common_button",
    staticStyle: {
      "margin-left": "2%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleContactAdmin($event)
      }
    }
  }, [_vm._v("联系管理员")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "15px",
      "padding-left": "100px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.agreed),
      callback: function($$v) {
        _vm.agreed = $$v
      },
      expression: "agreed"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showPrivacyAgreemenDialog
    }
  }, [_vm._v("登录视为已同意平台用户协议隐私政策")])])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "忘记密码"
    },
    on: {
      "close": _vm.cancelForgetPwdFormAddSubmit
    },
    model: {
      value: (_vm.forgetPwdDialogVisible),
      callback: function($$v) {
        _vm.forgetPwdDialogVisible = $$v
      },
      expression: "forgetPwdDialogVisible"
    }
  }, [_c('el-form', {
    ref: "forgetPwdForm",
    attrs: {
      "model": _vm.forgetPwdForm,
      "rules": _vm.forgetPwdFormRules
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "52px"
    }
  }, [_vm._v("请输入用户邮箱，密码重置链接将自动发送至您的邮箱。 ")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "22px",
      "width": "500px"
    },
    attrs: {
      "label": "邮箱",
      "prop": "email",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.forgetPwdForm.email),
      callback: function($$v) {
        _vm.$set(_vm.forgetPwdForm, "email", $$v)
      },
      expression: "forgetPwdForm.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelForgetPwdFormAddSubmit
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.addSubmitButtonDisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.forgetPwdFormOnSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "管理员"
    },
    on: {
      "close": _vm.cancelContactDialog
    },
    model: {
      value: (_vm.contactDialogVisible),
      callback: function($$v) {
        _vm.contactDialogVisible = $$v
      },
      expression: "contactDialogVisible"
    }
  }, [_c('span', [_vm._v("管理员邮箱为：cc.assistant@ap.jll.com ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.adminEmail),
      expression: "adminEmail",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    attrs: {
      "type": "button"
    }
  }, [_vm._v("点击复制")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancelContactDialog
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户隐私协议确认"
    },
    on: {
      "close": _vm.cancelAcceptPrivacyAgreementDialog
    },
    model: {
      value: (_vm.acceptPrivacyAgreementDialogVisible),
      callback: function($$v) {
        _vm.acceptPrivacyAgreementDialogVisible = $$v
      },
      expression: "acceptPrivacyAgreementDialogVisible"
    }
  }, [_c('span', [_vm._v("我已阅读并同意用户协议和隐私政策 ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAcceptPrivacyAgreementDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.acceptPrivacyAgreementButtonDisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.acceptPrivacyAgreementOnSubmit
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请输入邮箱验证码"
    },
    on: {
      "close": _vm.cancelVerifyEmailDialog
    },
    model: {
      value: (_vm.verifyEmailDialogVisible),
      callback: function($$v) {
        _vm.verifyEmailDialogVisible = $$v
      },
      expression: "verifyEmailDialogVisible"
    }
  }, [_c('el-form', {
    ref: "verifyEmailForm",
    attrs: {
      "model": _vm.verifyEmailForm,
      "rules": _vm.verifyEmailFormRules
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "52px"
    }
  }, [_vm._v("由于安全性相关考虑，需要进行身份验证才能进行登录已发送一封验证码邮件到您的邮箱地址 ")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "22px",
      "width": "500px"
    },
    attrs: {
      "label": "",
      "prop": "verifyCode",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邮箱内的验证码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.verifyEmailForm.verifyCode),
      callback: function($$v) {
        _vm.$set(_vm.verifyEmailForm, "verifyCode", $$v)
      },
      expression: "verifyEmailForm.verifyCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.verifyEmailButtonDisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.verifyEmailOnSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "JLL法律声明及隐私权政策"
    },
    on: {
      "close": _vm.cancelPrivacyAgreementContentDialog
    },
    model: {
      value: (_vm.privacyAgreementContentDialogVisible),
      callback: function($$v) {
        _vm.privacyAgreementContentDialogVisible = $$v
      },
      expression: "privacyAgreementContentDialogVisible"
    }
  }, [_c('div', {
    staticClass: "agreement-describe"
  }, [_c('span', [_vm._v("更新时间:" + _vm._s(_vm.agreementModifyTimeStr) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "ql-editor",
    staticStyle: {
      "color": "#000000"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.privacyAgreementContent)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancelPrivacyAgreementContentDialog
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav_bar"
  }, [_c('img', {
    attrs: {
      "src": require("img/logo.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system_name"
  }, [_c('img', {
    attrs: {
      "src": require("img/system_name.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d40e11"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/login.vue
// module id = 527
// module chunks = 1